/* Build The Look — reveal the collage grid once it scrolls into view.
   If the grid is already inside the viewport at load, it's left fully
   visible immediately (no animation) so it never delays LCP. */
(function () {
  function init() {
    var grids = document.querySelectorAll('.build-the-look__grid');
    if (!grids.length) return;

    var vh = window.innerHeight;
    var toObserve = [];

    grids.forEach(function (grid) {
      if (grid.dataset.revealChecked) return;
      grid.dataset.revealChecked = 'true';

      var rect = grid.getBoundingClientRect();
      var alreadyInView = rect.top < vh && rect.bottom > 0;

      if (alreadyInView) {
        return;
      }

      grid.classList.add('scroll-reveal-pending');
      toObserve.push(grid);
    });

    if (!toObserve.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
    );

    toObserve.forEach(function (grid) {
      observer.observe(grid);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
